<div class="notesWrapper">
    <div class="notesHeader">
        <div class="filters global-filters-container">
            <lib-search-input
                [(text)]="filterValue.searchText"
                (textChange)="onFilterChanged()"
                [placeholderText]="'Search notes'"
            >
            </lib-search-input>
            <lib-datepicker-dropdown
                defaultTitle="Created/Modified on"
                [(dateFrom)]="filterValue.dateFrom"
                [(dateTo)]="filterValue.dateTo"
                (filterChanged)="onFilterChanged()"
                [dateRangeEnabled]="true"
            >
            </lib-datepicker-dropdown>
            <app-generic-type-ahead
                [(selectedItem)]="filterValue.user"
                placeholder="Created by"
                (filterChanged)="onFilterChanged()"
                [service]="userServiceFilter"
                [config]="{
                    defaultText: 'User',
                    itemDisplayKey: 'fullName',
                    itemTemplate: userTemplate
                }"
            >
            </app-generic-type-ahead>
            <app-generic-type-ahead
                [(selectedItem)]="filterValue.noteUser"
                placeholder="Addressed to"
                (filterChanged)="onFilterChanged()"
                [service]="userServiceFilter"
                [config]="{
                    defaultText: 'User',
                    itemDisplayKey: 'fullName',
                    itemTemplate: userTemplate
                }"
            >
            </app-generic-type-ahead>
            <ng-template #userTemplate let-data>
                <app-custom-menu-item
                    [inputText]="data.inputText"
                    [title]="
                        $safeNavigationMigration(data.object?.firstName) +
                        ' ' +
                        $safeNavigationMigration(data.object?.lastName)
                    "
                    [subtitle]="data.object?.email ?? ''"
                    [titlePrefix]="!data.object?.isActive ? { text: 'Inactive', textColor: 'danger' } : undefined"
                >
                </app-custom-menu-item>
            </ng-template>
        </div>

        <div class="actions">
            <button class="secondary-btn small newNoteButton" (click)="createNote()">
                <span class="icon" [innerHTML]="plusIcon"></span> New Note
            </button>
        </div>
    </div>

    @if (notes?.length === 0) {
        <lib-no-data
            [iconName]="'empty'"
            [title]="'There are no related notes yet!'"
            linkText="Create New Note"
            (linkAction)="createNote()"
        >
        </lib-no-data>
    } @else {
        @if (notes) {
            <lib-tab-view
                [direction]="'column'"
                [separation]="'wide'"
                [(currentTab)]="currentTab"
                [(paginationConfig)]="paginationConfig"
                (paginationConfigChange)="refreshTabView()"
            >
                @for (note of notes; track note.id; let i = $index) {
                    <lib-tab-item
                        [tabName]="note.noteKey"
                        [headerTemplate]="noteTabItem"
                        [bodyTemplate]="noteTabContent"
                    >
                        <ng-template #noteTabItem>
                            <div class="tabItem">
                                <span class="subtitle">{{ note.modificationDate | date }}</span>
                                <span class="title">{{ note.title }}</span>
                                <p class="content">{{ note.message }}</p>
                            </div>
                        </ng-template>
                        <ng-template #noteTabContent>
                            <app-note-content
                                [noteId]="note.id"
                                [index]="i"
                                [entityName]="entityName"
                                [organizationId]="organizationId"
                                (noteChanged)="onNoteChanged($event)"
                            ></app-note-content>
                        </ng-template>
                    </lib-tab-item>
                }
            </lib-tab-view>
        }
    }
</div>
